import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as EquipmentActivityActions from '../_actions/equipmentActivity';
import { EquipmentActivity } from '../_models';

export interface EquipmentActivityState extends EntityState<EquipmentActivity> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<EquipmentActivity> = createEntityAdapter<EquipmentActivity>();

const initialState: EquipmentActivityState = adapter.getInitialState({
  loading: false,
  error: null,
});

const equipmentActivityReducer = createReducer(
  initialState,

  on(EquipmentActivityActions.loadEquipmentActivities, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(EquipmentActivityActions.loadEquipmentActivitiesSuccess, (state, { equipmentActivities }) =>
    adapter.setAll(equipmentActivities, { ...state, loading: false })
  ),

  on(EquipmentActivityActions.loadEquipmentActivitiesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(EquipmentActivityActions.addEquipmentActivitySuccess, (state, { equipmentActivity }) =>
    adapter.addOne(equipmentActivity, state)
  ),

  on(EquipmentActivityActions.updateEquipmentActivitySuccess, (state, { equipmentActivity }) =>
    adapter.upsertOne(equipmentActivity, state)
  ),

  on(EquipmentActivityActions.deleteEquipmentActivitySuccess, (state, { id }) =>
    adapter.removeOne(id, state)
  ),

  on(
    EquipmentActivityActions.addEquipmentActivityFailure,
    EquipmentActivityActions.updateEquipmentActivityFailure,
    EquipmentActivityActions.deleteEquipmentActivityFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: EquipmentActivityState | undefined, action: Action) {
  return equipmentActivityReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
